import React from "react"
import { Map as MapComponent } from "@outdoormap/gatsby-plugin-brand-sites"

import { customCategoryNames } from "../../config/category"

export default function Map(props) {
  return <MapComponent categoryNames={customCategoryNames} {...props} />
}
